export const focusHandling = (prop = null) => {
    // make focus ring visible only for keyboard navigation
    const focusEls = document.querySelectorAll('a, button, input, select, textarea, label, .form-switch, [tabindex]');
    const resetFocusEls = (bool) => {
        const outlineStyle = bool ? '' : 'none';
        focusEls.forEach((focusTab) => {
            (!prop || prop === 'outline') && focusTab.style.setProperty('outline', outlineStyle);
            (!prop || prop === 'box-shadow') && focusTab.style.setProperty('box-shadow', outlineStyle);
        });
    };
    const detectClick = () => {
        if (focusEls.length > 0) {
            resetFocusEls(false);
            // eslint-disable-next-line no-use-before-define
            window.addEventListener('keydown', detectTab);
        }
        window.removeEventListener('mousedown', detectClick);
    };
    const detectTab = (event) => {
        if (event.keyCode !== 9)
            return;
        resetFocusEls(true);
        window.removeEventListener('keydown', detectTab);
        window.addEventListener('mousedown', detectClick);
    };
    window.addEventListener('mousedown', detectClick);
};
